// DialogActionsWrapper.jsx
import { Typography } from '@mui/material';
import React, { useState } from 'react';
import { useSelector } from 'react-redux';

import CustomAlert from '../../../../../../../../../../../../../lib/designSystem/Alert';
import CustomButton from '../../../../../../../../../../../../../lib/designSystem/Button';
import { validatePermissions } from '../../../../../../../../../../../../../lib/functions/utils';
import { AuthState } from '../../../../../../../../../../../../../services/redux/authSlice';
import CreditDeleteModal from './components/CreditDeleteModal';
import FactoringRequestDeleteConfirmationModal from './components/DeleteModal';
import FactoringRequestUpdateStatusModal from './components/UpdateStatusModal';

export interface UpdateStatusTransitions {
  [key: string]: { key: string; label: string }[];
}

const DialogActionsWrapper = ({
  type,
  onClose,
  actions,
  selectedRequest,
  setUp,
  setOpenShoppingCart,
  selectedId,
  currentPage,
  currentPageSize,
  loading = false,
}: any) => {
  const [openDeleteConfirm, setOpenDeleteConfirm] = useState(false);
  const [openUpdateStatus, setOpenUpdateStatus] = useState(false);
  const user = useSelector((state: { auth: AuthState }) => state.auth.user);
  const [success, setSuccess] = useState(false);
  const [successText, setSuccessText] = useState('');
  const [failed, setFailed] = useState(false);
  const [failedMessage, setFailedMessage] = useState('');

  const updateStatusTransitions: UpdateStatusTransitions = {
    Aceptada: [
      {
        key: 'IN_REVIEW',
        label: 'En revisión',
      },
    ],
    Rechazada: [
      {
        key: 'IN_REVIEW',
        label: 'En revisión',
      },
    ],
    'En giro': [
      ...(selectedRequest.quoteActive?.comiteeOperations
        ? [
            {
              key: 'ACCEPTED',
              label: 'Aceptada',
            },
          ]
        : [
            {
              key: 'IN_REVIEW',
              label: 'En revisión',
            },
          ]),
    ],
  };

  const setSuccessOpen = (text: string) => {
    setSuccess(true);
    setSuccessText(text);
    setOpenUpdateStatus(false);
    setOpenDeleteConfirm(false);
  };

  const setFailureOpen = (text: string) => {
    setFailed(true);
    setFailedMessage(text);
    setOpenUpdateStatus(false);
    setOpenDeleteConfirm(false);
  };

  const canDeleteRequest = () => {
    if (!selectedRequest.id) return false;
    if (validatePermissions(user, 'financing_factoring_delete')) return true;
    return false;
  };

  const canEditRequest = () => {
    if (
      !updateStatusTransitions[selectedRequest.status] ||
      updateStatusTransitions[selectedRequest.status].length === 0
    )
      return false;
    if (!validatePermissions(user, 'financing_factoring_edit_operation_status'))
      return false;
    return true;
  };

  const handleOpenDeleteConfirmModal = (id: number) => {
    setOpenDeleteConfirm(true);
  };

  const handleOpenUpdateStatusModal = (id: number) => {
    setOpenUpdateStatus(true);
  };

  return (
    <div
      style={{
        width: '100%',
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        padding: '10px 0px',
        gap: '10px',
      }}
    >
      {canDeleteRequest() && (
        <Typography
          color="error"
          variant="body1"
          fontWeight="bold"
          style={{ cursor: 'pointer' }}
          onClick={() => handleOpenDeleteConfirmModal(selectedRequest.id)}
        >
          Eliminar
        </Typography>
      )}

      {canEditRequest() && !loading && (
        <Typography
          color="orange"
          variant="body1"
          fontWeight="bold"
          style={{ cursor: 'pointer' }}
          onClick={() => handleOpenUpdateStatusModal(selectedRequest.id)}
        >
          Editar Estado
        </Typography>
      )}
      <div style={{ display: 'flex', gap: '10px', marginLeft: 'auto' }}>
        <CustomButton onClick={onClose} color="secondary" disabled={loading}>
          Salir
        </CustomButton>
        {actions}
      </div>
      {openDeleteConfirm &&
        (type === 'factoring' ? (
          <FactoringRequestDeleteConfirmationModal
            open={openDeleteConfirm}
            setOpen={setOpenDeleteConfirm}
            requestId={selectedRequest.id}
            setUp={setUp}
          />
        ) : (
          <CreditDeleteModal
            open={openDeleteConfirm}
            setOpen={setOpenDeleteConfirm}
            onClose={onClose}
            setOpenShoppingCart={setOpenShoppingCart}
            requestId={selectedRequest.id}
            setUp={setUp}
            setSuccessOpen={setSuccessOpen}
            setFailureOpen={setFailureOpen}
            currentPage={currentPage}
            currentPageSize={currentPageSize}
          />
        ))}
      {openUpdateStatus && (
        <FactoringRequestUpdateStatusModal
          updateStatusTransitions={updateStatusTransitions}
          open={openUpdateStatus}
          setOpen={setOpenUpdateStatus}
          requestId={selectedRequest.id}
          setUp={setUp}
          oldStatus={selectedRequest.status}
          selectedId={selectedId}
        />
      )}
      <CustomAlert
        setOpen={setSuccess}
        open={success}
        title="Exito"
        text={successText}
        severity="success"
      />
      <CustomAlert
        setOpen={setFailed}
        open={failed}
        title="Oops"
        text={failedMessage}
        severity="error"
      />
    </div>
  );
};
export default DialogActionsWrapper;
